import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../../services/auth';
import {User} from '../../../classes/user';
import {Checklist} from '../../../classes/checklist';
import {ChecklistService} from '../../../services/checklist';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {ChecklistCategory} from "../../../classes/checklistCategory";
import {ChecklistCategoryService} from "../../../services/checklistCategory";

@Component({
    selector: 'app-checklist-detail',
    templateUrl: './checklist-detail.component.html',
    styleUrls: ['./checklist-detail.component.css']
})
export class ChecklistDetailComponent implements OnInit {
    // Pagination Parameters
    paginationConfig = {
        itemsPerPage: 10,
        currentPage: 1
    };
    paginationParams = {
        autoHide: true,
        maxSize: 7,
        responsive: true
    };
    paginationLabels = {
        previousLabel: 'Precedente',
        nextLabel: 'Successiva',
        screenReaderPaginationLabel: 'Paginazione',
        screenReaderPageLabel: 'pagina',
        screenReaderCurrentLabel: `Sei sulla pagina`
    };

    // Checklist Data
    user!: User;
    checklist!: Checklist;
    checklistCategories: Array<ChecklistCategory> = [];
    checklistSubCategories: Array<boolean> = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private modalService: NgbModal,
                private checklistService: ChecklistService,
                private checklistCategoryService: ChecklistCategoryService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.checklistService.getByID(params.get('id'))
                .subscribe({
                    next: (checklist: any) => {
                        this.checklist = checklist;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
            this.checklistCategoryService.getByChecklistID(params.get('id'))
                .subscribe({
                    next: (checklistCategories: any) => {
                        this.checklistCategories = checklistCategories;
                        this.checklistCategories.forEach(() => {
                            this.checklistSubCategories.push(false);
                        });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
        this.user = this.authService.getUser();
    }

    pageChanged(event: any) {
        this.paginationConfig.currentPage = event;
    }

    openDuplicateChecklistModal() {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Duplicazione <strong>Checklist</strong>';
        modalRef.componentInstance.text = 'Confermi la duplicazione della checklist "' + this.checklist.name + '"?';
        modalRef.result.then(() => {
            if (this.checklist.id_checklist) {
                this.checklistService.duplicate(this.checklist)
                    .subscribe({
                        next: () => {
                            this.router.navigate(['/checklist']);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openDeleteChecklistModal() {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Checklist</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione della checklist "' + this.checklist.name + '"?';
        modalRef.result.then(() => {
            if (this.checklist.id_checklist) {
                this.checklistService.delete(this.checklist.id_checklist)
                    .subscribe({
                        next: () => {
                            this.router.navigate(['/checklist']);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openDeleteChecklistCategoryModal(checklistCategory: ChecklistCategory) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Macro Categoria</strong> Checklist';
        modalRef.componentInstance.text = 'Confermi la rimozione della macro categoria "' + checklistCategory.name + '"?';
        modalRef.result.then(() => {
            if (checklistCategory.id_checklist_category) {
                this.checklistCategoryService.delete(checklistCategory.id_checklist_category)
                    .subscribe({
                        next: () => {
                            this.checklistCategories = this.checklistCategories.filter((currChecklistCategory: ChecklistCategory) =>
                                currChecklistCategory.id_checklist_category !== checklistCategory.id_checklist_category);
                            this.paginationConfig.currentPage = 1;
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }
}
